/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Base estimate record returned by the API.
 * @export
 * @interface Estimate
 */
export interface Estimate {
    /**
     * 
     * @type {number}
     * @memberof Estimate
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof Estimate
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof Estimate
     */
    documentId?: number | null;
    /**
     * Source system that generated the estimate
     * @type {string}
     * @memberof Estimate
     */
    sourceSystem: EstimateSourceSystemEnum;
    /**
     * Type of estimate
     * @type {string}
     * @memberof Estimate
     */
    kind: EstimateKindEnum;
    /**
     * Subtotal in cents
     * @type {number}
     * @memberof Estimate
     */
    subtotalCents: number;
    /**
     * Taxes in cents
     * @type {number}
     * @memberof Estimate
     */
    taxesCents: number;
    /**
     * Depreciation in cents
     * @type {number}
     * @memberof Estimate
     */
    depreciationCents: number;
    /**
     * Total value in cents
     * @type {number}
     * @memberof Estimate
     */
    totalCents: number;
    /**
     * 
     * @type {Date}
     * @memberof Estimate
     */
    readonly createdAt: Date;
}


/**
 * @export
 */
export const EstimateSourceSystemEnum = {
    Xactimate: 'xactimate',
    Symbility: 'symbility',
    Other: 'other'
} as const;
export type EstimateSourceSystemEnum = typeof EstimateSourceSystemEnum[keyof typeof EstimateSourceSystemEnum];

/**
 * @export
 */
export const EstimateKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type EstimateKindEnum = typeof EstimateKindEnum[keyof typeof EstimateKindEnum];


/**
 * Check if a given object implements the Estimate interface.
 */
export function instanceOfEstimate(value: object): value is Estimate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('sourceSystem' in value) || value['sourceSystem'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('subtotalCents' in value) || value['subtotalCents'] === undefined) return false;
    if (!('taxesCents' in value) || value['taxesCents'] === undefined) return false;
    if (!('depreciationCents' in value) || value['depreciationCents'] === undefined) return false;
    if (!('totalCents' in value) || value['totalCents'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function EstimateFromJSON(json: any): Estimate {
    return EstimateFromJSONTyped(json, false);
}

export function EstimateFromJSONTyped(json: any, ignoreDiscriminator: boolean): Estimate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'sourceSystem': json['sourceSystem'],
        'kind': json['kind'],
        'subtotalCents': json['subtotalCents'],
        'taxesCents': json['taxesCents'],
        'depreciationCents': json['depreciationCents'],
        'totalCents': json['totalCents'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function EstimateToJSON(json: any): Estimate {
    return EstimateToJSONTyped(json, false);
}

export function EstimateToJSONTyped(value?: Omit<Estimate, 'id'|'createdAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'documentId': value['documentId'],
        'sourceSystem': value['sourceSystem'],
        'kind': value['kind'],
        'subtotalCents': value['subtotalCents'],
        'taxesCents': value['taxesCents'],
        'depreciationCents': value['depreciationCents'],
        'totalCents': value['totalCents'],
    };
}

